import { IAddorEditEntityInstanceResponse } from '../components/Entity/EntityInstance/interfaces'
import { AvailableOrgList } from '../redux/slices/entityInstanceSlice'
import { IShareOrganization } from '../components/Layout/Navbar/interfaces'
import { axiosInstance, axiosInstanceEntity } from './axiosInstance'

export const fetchEntityInstanceData = async (
    orgId: string,
    templateId: string,
    entityId: string,
    isGuestUser?: boolean,
): Promise<IAddorEditEntityInstanceResponse> => {
    const path = isGuestUser
        ? `/coldChain/public/entity?orgId=${orgId}&templateId=${templateId}&entityId=${entityId}`
        : `/entity?orgId=${orgId}&templateId=${templateId}&entityId=${entityId}`
    return await axiosInstanceEntity
        .get(path, {
            isGuestUser,
        } as any)
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}

export const fetchSubTemplates = async (
    orgId: string,
    templateId: string,
): Promise<unknown> => {
    return await axiosInstanceEntity
        .get(`/template/subTypes?entityTemplateId=${templateId}&orgId=${orgId}`)
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}

export const fetchProgramOrgsByOrgId = async (
    orgId: string,
): Promise<IShareOrganization[]> => {
    return await axiosInstance
        .get(`/program/orgs?ownerOrganization=${orgId}`)
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}

export const fetchSealineAndFacilityData = async (
    params: unknown,
): Promise<{ data?: unknown[] }> => {
    return await axiosInstanceEntity
        .get(`/staticData`, {
            params,
        })
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}

export const fetchRecordsUIDsByTemplateId = async (
    orgId: string,
    templateId: string,
    params?: unknown,
): Promise<{ data: unknown[]; action?: string }> => {
    return await axiosInstanceEntity
        .get(`/entity/uids?orgId=${orgId}&templateId=${templateId}`, {
            params,
        })
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}

export const fetchBusinessRuleSetsOnly = async (
    orgId: string,
    templateId: string,
    params?: unknown,
): Promise<{ ruleSets?: unknown[] }> => {
    return await axiosInstanceEntity
        .get(`/rule/rulesets/${orgId}?entityTemplateId=${templateId}`, {
            params,
        })
        .then((response) => {
            return response?.data || []
        })
        .catch((err) => {
            return err.response
        })
}

export const fetchRulesetsForProduct = async (
    orgId: string,
    productId: string,
): Promise<{ id: string; name: string }[]> => {
    return await axiosInstanceEntity
        .get(`/entity/product/ruleSets?orgId=${orgId}&productId=${productId}`)
        .then((response) => {
            return response?.data?.ruleSets || []
        })
        .catch((err) => {
            return err.response
        })
}
export const fetchAvalibleOrgsAndTemplates = async (
    orgId: string,
    templateId: string,
): Promise<AvailableOrgList[]> => {
    return await axiosInstanceEntity
        .get(`/entity/org/subTypes?orgId=${orgId}&templateId=${templateId}`)
        .then((response) => {
            return response?.data?.data || []
        })
        .catch((err) => {
            return err.response
        })
}
